import { provideWidgetClass } from "scrivito"
import { Alignment } from "shared/lib/layout/Alignment"

export const DataFormSubmitButtonWidget = provideWidgetClass(
  "DataFormSubmitButtonWidget",
  {
    attributes: {
      submitTitle: "string",
      hasCancel: "boolean",
      cancelTitle: "string",
      size: ["enum", { values: ["small", "medium", "large"] }],
      alignment: ["enum", { values: Object.values(Alignment) }],
      cancelAndBackToUrl: "string"
    }
  }
)
